import { render } from "./FirstBuyPage.vue?vue&type=template&id=17cc92ae&scoped=true"
import script from "./FirstBuyPage.vue?vue&type=script&lang=js"
export * from "./FirstBuyPage.vue?vue&type=script&lang=js"

import "./FirstBuyPage.vue?vue&type=style&index=0&id=17cc92ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17cc92ae"]])

export default __exports__